import * as Api from "./api";

const FS = "FeatureSwitch";
export const FEATURE_SWITCH_CHANGED_EVENT = "feature-switch-changed";

// Broadcast a global event so listeners (e.g. HeaderMenu) can refetch
// without requiring a hard reload.
export function notifyFeatureSwitchChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FEATURE_SWITCH_CHANGED_EVENT));
  }
}

// Always available — global flag lookup. Used to gate UI against global feature flags.
export function getGlobalFlag(featureId) {
  return Api.getRequest(`${FS}/feature/${featureId}`);
}

// Global feature switch admin (existing endpoints)
export function getAllGlobalFlags() {
  return Api.getRequest(Api.URI_GetFeatureSwitches);
}

export function upsertGlobalFlag(payload) {
  // payload: { id, taskId, taskName, isEnabled }
  return Api.postRequest(Api.URI_UpsertFeatureSwitch, payload);
}

// StubUser-only endpoints below. Non-StubUser callers receive HTTP 403.

export function getStubState(userId) {
  return Api.getRequest(`${FS}/stub/${userId}`);
}

export function enableStub(userId) {
  return Api.postRequest(`${FS}/stub/${userId}/enable`, undefined);
}

export function disableStub(userId) {
  return Api.postRequest(`${FS}/stub/${userId}/disable`, undefined);
}

export function getUserView(userId) {
  return Api.getRequest(`${FS}/user/${userId}`);
}

export function setUserOverride(userId, taskID, isEnabled) {
  return Api.postRequest(`${FS}/user/${userId}/override`, {
    TaskID: taskID,
    IsEnabled: isEnabled,
  });
}

export function deleteUserOverride(userId, taskId) {
  return Api.deleteRequest(`${FS}/user/${userId}/override/${taskId}`);
}
